// File: src/pages/PrivacyTab.js

import React from 'react';

function PrivacyTab() {
    return (
        <>
            <div className="card">
                {/* Card header START */}
                <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Privacy and safety</h5>
                    <p className="mb-0">
                        See information about your account, download an archive of
                        your data, or learn about your account deactivation options
                    </p>
                </div>
                {/* Card header START */}
                {/* Card body START */}
                <div className="card-body">
                    {/* Privacy START */}
                    <ul className="list-group">
                        {/* Privacy items */}
                        <li className="list-group-item d-md-flex justify-content-between align-items-start">
                            <div className="me-md-3">
                                <h6 className="mb-0">Use two-factor authentication</h6>
                                <p className="small mb-0">
                                    Unaffected occasional thoroughly. Adieus it no
                                    wonders spirit houses.
                                </p>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                        <li className="list-group-item d-md-flex justify-content-between align-items-start">
                            <div className="me-md-3">
                                <h6 className="mb-0">Login activity</h6>
                                <p className="small mb-0">
                                    Select the language you use on social
                                </p>
                            </div>
                            <button
                                className="btn btn-primary-soft btn-sm mt-1 mt-md-0"
                                data-bs-toggle="modal"
                                data-bs-target="#modalLoginActivity"
                            >
                                <i className="bi bi-eye"></i> View
                            </button>
                        </li>
                        <li className="list-group-item d-md-flex justify-content-between align-items-start">
                            <div className="me-md-3">
                                <h6 className="mb-0">Manage your data and activity</h6>
                                <p className="small mb-0">
                                    Select a language for translation
                                </p>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                        <li className="list-group-item d-md-flex justify-content-between align-items-start">
                            <div className="me-md-3">
                                <h6 className="mb-0">Search history</h6>
                                <p className="small mb-0">
                                    Choose to autoplay videos on social
                                </p>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                        <li className="list-group-item d-md-flex justify-content-between align-items-start">
                            <div className="me-md-3">
                                <h6 className="mb-0">Permitted services</h6>
                                <p className="small mb-0">
                                    Choose if this feature appears on your profile
                                </p>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                    </ul>
                    {/* Privacy END */}
                </div>
                {/* Card body END */}
                {/* Button save */}
                <div className="card-footer pt-0 text-end border-0">
                    <button type="submit" className="btn btn-sm btn-primary mb-0">
                        Save changes
                    </button>
                </div>
            </div>
        </>
    );
}

export default PrivacyTab;